<template>
    <v-container fluid>
        <v-card class="elevation-3" :loading="loading">
            <div class="card-title">{{ $t('Lookups') }}</div>
            <v-card-text>
                <v-data-table :headers="headers" dense :items="lookups" :items-per-page="10">
                    <template v-slot:[`item.options`]="{ item }">
                        <v-icon color="primary" @click="openLookupItem(item.id,item.nameEn)"> mdi-table</v-icon>
                        <v-icon color="secondary" class="mx-3" @click="editLookup(item)"> mdi-pen</v-icon>
                        <v-icon color="error" @click="deleteLookup(item.id)"> mdi-trash-can-outline</v-icon>
                    </template>
                    <template v-slot:top>
                        <v-btn small class="ma-4 white--text" tile color="primary" @click="open()">
                            {{ $t('Add') }} <v-icon small class="ms-2">mdi-plus</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </v-card-text>
            <v-form ref="LookupForm" v-model="valid" lazy-validation>
                <CommonDialog v-model="dialog" :fullscreen="false" width="500" :title="title" show-action-toolbar>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field v-model="lookup.NameEn" :label="$t('NameEn')" :rules="nameRules" required />
                            </v-col>
                            <v-col cols="12">
                                <v-text-field v-model="lookup.NameAr" :label="$t('NameAr')" :rules="nameRules" required />
                            </v-col>
                            <v-col>
                                <v-checkbox v-model="isChecked" :label="$t('ForSurvey')" @change="checkboxSurveyChanged"></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox v-model="isSurveyChecked" v-if="showSecondCheckbox" :label="$t('RelatedTo')" @change="checkboxRelatedChanged"></v-checkbox>
                            </v-col>
                            <v-col cols="12">
                                <v-select v-model="selectedItem" :items="itemsForDropdown" :label="$t('SelectRelatedLookup')" outlined v-if="showSecondDropDown" item-text="name" item-value="id"></v-select>
                            </v-col>
                        </v-row>
                    </v-container>

                    <template v-slot:actions>
                        <v-btn v-if="!edit" color="primary" class="white--text" tile :disabled="loading" small @click="save()">
                            {{ $t("Add") }}
                        </v-btn>
                        <v-btn v-if="edit" color="primary" class="white--text" tile :disabled="loading" small @click="update()">
                            {{ $t("Update") }}
                        </v-btn>
                        <v-btn color="error" class="white--text" tile :disabled="loading" small @click="dialog = false; reset()">
                            {{ $t("Cancel") }}
                        </v-btn>
                    </template>
                </CommonDialog>
            </v-form>

            <v-form ref="LookupItemForm" v-model="valid" lazy-validation>
                <CommonDialog v-model="dialogItems" :fullscreen="true" :title="title" show-action-toolbar>
                    <v-card>
                        <div class="card-title">{{ $t('LookUpItems') }}</div>
                        <v-card-text class="mt-4">
                            <v-row>
                                <v-col cols="2">
                                    <v-text-field outlined dense v-model="lookupItem.Id" type="number" :label="$t('Id')" :disabled="editItem"></v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field outlined dense v-model="lookupItem.NameEn" :label="$t('NameEn')"></v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field outlined dense v-model="lookupItem.NameAr" :label="$t('NameAr')"></v-text-field>
                                </v-col>
                                <v-col cols="3" v-if="showDropDownifLookupRelated">
                                    <v-select dense v-model="selectedItemFromRelatedLookup" :items="itemsForLookupRelatedParent" :label="$t('SelectRelatedLookup')" outlined item-text="name" item-value="id"></v-select>
                                </v-col>
                                <v-col cols="1">
                                    <v-btn tile color="primary" dense @click="saveLookUpItem" v-if="!editItem">{{ $t('Add') }}</v-btn>
                                    <v-btn tile color="primary" dense @click="updateLookupItem" v-else>{{ $t('Edit') }}</v-btn>
                                </v-col>
                            </v-row>
                            <v-data-table :headers="headers2" dense :items="lookupItems" :items-per-page="10">
                                <template v-slot:[`item.actions`]="{ item }">
                                    <v-icon color="secondary" @click="editLookupItem(item)"> mdi-pen</v-icon>
                                    <v-icon color="error" @click="deleteLookupItem(item)"> mdi-delete</v-icon>
                                </template>
                            </v-data-table>

                        </v-card-text>
                    </v-card>
                </CommonDialog>
            </v-form>
        </v-card>
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex'
    import CommonDialog from '@/components/controls/CommonDialog'
    import LookupAdminService from '@/services/LookupAdminServices.js'

    export default {

        components: {
            CommonDialog
        },

        data() {
            return {
                loading: false,
                dialog: false,
                dialogItems: false,
                valid: true,
                edit: false,
                editItem: false,
                isChecked: false,
                isSurveyChecked: false,
                selectedLookupId: null,
                selectedLookupItemId: null,
                lookups: [],
                NotRelatedLookups: [],
                lookupItems: [],
                headers: [
                    { text: this.$t('Id'), value: 'id' },
                    { text: this.$t('LookupName'), value: 'nameEn' },
                    { text: this.$t('NameAr'), value: 'nameAr' },
                    { text: this.$t('Options'), value: 'options', width: '12%' }
                ],
                headers2: [
                    { text: this.$t('RecordPK'), value: 'recordPK', align: 'start', width: '10%', sortable: false },
                    //{ text: 'LookupId', value: 'lookupId', align: 'start', width: '10%', sortable: false },
                    { text: this.$t('LookupName'), value: 'lookupName', align: 'start', width: '10%', sortable: false },
                    { text: this.$t('Id'), value: 'id', align: 'start', width: '10%', sortable: false },
                    { text: this.$t('Name'), value: 'nameEn', align: 'start', width: '30%', sortable: false },
                    { text: this.$t('NameAr'), value: 'nameAr', align: 'start', width: '30%', sortable: false },
                    { text: this.$t('Actions'), value: 'actions', align: 'start', width: '10%', sortable: false },
                ],
                title: '',
                nameRules: [
                    v => !!v || this.$t('RequiredField')
                ],
                lookup: {
                    NameEn: '',
                    NameAr: '',
                    ForSurvey: false,
                    LookupIdRelatedTo: ''
                },
                lookupFull: { Id: '', NameEn: '', NameAr: '', ForSurvey: false, LookupIdRelatedTo: '' },
                lookupItem: { LookupId: '', Id: '', NameEn: '', NameAr: '', ItemFromRelatedLookup: '' },
                lookupItemsFull: { RecordPK: '', lookupId: '', id: '', NameEn: '', NameAr: '', ItemFromRelatedLookup: '' },
                selectedItem: null,
                itemsDrop: [],
                isParetRelated: false,
                itemsParetRelated: [],
                selectedItemFromRelatedLookup: null,
                ParentLookupName: ''
            }
        },
        created() {
            this.loadLookups()
            //this.loadRoleTypes()
        },
        computed: {
            ...mapGetters('user', ['language']),
            getLanguage() {
                return this.language == null ? 'ar' : this.language

            },
            showSecondCheckbox() {
                return this.isChecked
            },
            showSecondDropDown() {
                return this.isSurveyChecked
            },
            itemsForDropdown() {
                //const options = [{ id: 0, name: 'Select an Item' }].concat(this.lookups)
                //return options.map(item => ({ id: item.id, name: item.name }))
                var language = this.getLanguage
                this.loadNotRelatedLookups()
                return this.NotRelatedLookups.filter(item => item.id !== this.selectedLookupId)
                    .map(item => ({
                        id: item.id,
                        name: language == 'ar' ? item.nameAr : item.nameEn
                    }))
            },
            showDropDownifLookupRelated() {
                return this.isParetRelated
            },
            itemsForLookupRelatedParent() {
                var language = this.getLanguage
                return this.itemsParetRelated.map(item => ({ id: item.recordPK, name: language == 'ar' ? item.nameAr : item.nameEn }))
            }
        },
        methods: {
            loadLookups() {
                this.loading = true
                LookupAdminService.listLookups().then((res) => {
                    this.lookups = res.data

                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
            loadNotRelatedLookups() {
                this.loading = true
                LookupAdminService.listNotRelatedLookups().then((res) => {
                    this.NotRelatedLookups = res.data

                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
            loadLookupItems() {
                this.loading = true
                LookupAdminService.listLookupItems(this.selectedLookupId).then((res) => {

                    let resValue = res.data.forEach(obj => { obj.lookupName = this.ParentLookupName })
                    this.lookupItems = res.data

                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
            openLookupItem(id, lookupName) {
                this.resetItem()
                this.selectedLookupId = id
                this.ParentLookupName = lookupName
                this.dialogItems = true
                const filteredData = this.lookups.filter(item => item.id === id && item.lookupIdRelatedTo != null)
                if (filteredData.length > 0) {
                    this.isParetRelated = true
                    const lookupParentId = filteredData[0].lookupIdRelatedTo
                    this.loadLookupItemsByLookupId(lookupParentId)
                } else {
                    this.isParetRelated = false
                }
                this.loadLookupItems()
            },
            loadLookupItemsByLookupId(lookupParentId) {
                LookupAdminService.listLookupItems(lookupParentId).then((res) => {

                    let resValue = res.data.forEach(obj => { obj.lookupName = this.ParentLookupName })
                    this.itemsParetRelated = res.data

                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
            save() {
                if (this.$refs.LookupForm.validate()) {
                    this.lookupFull.Id = 0
                    this.lookupFull.NameEn = this.lookup.NameEn
                    this.lookupFull.NameAr = this.lookup.NameAr
                    this.lookupFull.ForSurvey = this.showSecondCheckbox
                    this.lookupFull.LookupIdRelatedTo = this.selectedItem

                    LookupAdminService.addLookup(this.lookupFull).then((res) => {
                        this.loadLookups()
                        this.reset()
                        this.$refs.LookupForm.resetValidation()
                    }).catch(() => {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    }).finally(() => {
                        this.loading = false
                    })
                }
            },
            saveLookUpItem() {
                if (this.$refs.LookupItemForm.validate()) {

                    this.lookupItem.LookupId = this.selectedLookupId
                    this.lookupItem.ItemFromRelatedLookup = this.selectedItemFromRelatedLookup
                    LookupAdminService.addLookupItems(this.lookupItem).then((res) => {
                        this.loadLookupItems()
                        this.resetItem()
                        this.$refs.LookupItemForm.resetValidation()
                    }).catch(() => {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    }).finally(() => {
                        this.loading = false
                    })
                }
            },
            update() {
                if (this.$refs.LookupForm.validate()) {
                    this.lookupFull.Id = this.selectedLookupId
                    this.lookupFull.NameEn = this.lookup.NameEn
                    this.lookupFull.NameAr = this.lookup.NameAr
                    this.lookupFull.ForSurvey = this.showSecondCheckbox
                    if (this.isSurveyChecked) {
                        this.lookupFull.LookupIdRelatedTo = this.selectedItem
                    } else {
                        this.lookupFull.LookupIdRelatedTo = null
                    }


                    LookupAdminService.updateLookup(this.selectedLookupId, this.lookupFull).then((res) => {
                        this.dialog = false
                        this.loadLookups()
                        this.reset()
                    }).catch(() => {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    }).finally(() => {
                        this.loading = false
                    })
                }
            },

            reset() {
                this.lookup.NameEn = ''
                this.lookup.NameAr = ''
                this.selectedLookupId = null
                this.showSecondCheckbox = false
                this.isSurveyChecked = false
                this.lookupFull.LookupIdRelatedTo = null
            },
            resetItem() {
                this.lookupItem.LookupId = ''
                this.lookupItem.Id = ''
                this.lookupItem.NameEn = ''
                this.lookupItem.NameAr = ''
                this.selectedLookupItemId = null
                this.selectedItemFromRelatedLookup = null
                this.editItem = false
            },
            open() {

                this.reset()
                this.edit = false
                this.selectedLookupId = null
                this.showSecondCheckbox = false
                this.isSurveyChecked = false
                this.lookupFull.LookupIdRelatedTo = null
                this.$refs.LookupForm.resetValidation()
                this.title = this.$t('Add')
                this.dialog = true
            },
            editLookup(item) {
                this.edit = true
                this.lookup.NameEn = item.nameEn
                this.lookup.NameAr = item.nameAr
                this.isChecked = item.forSurvey
                if (item.lookupIdRelatedTo !== 0 && item.lookupIdRelatedTo !== null) {
                    this.isSurveyChecked = true
                    this.selectedItem = item.lookupIdRelatedTo
                } else {
                    this.isSurveyChecked = false
                    this.selectedItem = 0
                }

                this.selectedLookupId = item.id
                this.title = this.$t('Edit')
                this.dialog = true
            },

            editLookupItem(item) {
                this.editItem = true
                this.lookupItem.LookupId = item.lookupId
                this.lookupItem.Id = item.id
                this.lookupItem.NameEn = item.nameEn
                this.lookupItem.NameAr = item.nameAr
                this.selectedLookupItemId = item.recordPK
                this.selectedItemFromRelatedLookup = item.itemFromRelatedLookup
                this.title = this.$t('Edit')
            },
            updateLookupItem() {
                if (this.$refs.LookupItemForm.validate()) {
                    this.lookupItemsFull.RecordPK = this.selectedLookupItemId
                    this.lookupItemsFull.lookupId = this.lookupItem.LookupId
                    this.lookupItemsFull.id = this.lookupItem.Id
                    this.lookupItemsFull.NameEn = this.lookupItem.NameEn
                    this.lookupItemsFull.NameAr = this.lookupItem.NameAr
                    this.lookupItemsFull.ItemFromRelatedLookup = this.selectedItemFromRelatedLookup

                    LookupAdminService.updateLookupItem(this.selectedLookupItemId, this.lookupItemsFull).then((res) => {
                        this.loadLookupItems()
                        this.resetItem()
                    }).catch(() => {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    }).finally(() => {
                        this.loading = false
                    })
                }
            },
            async deleteLookup(id) {
                if (await this.$root.$confirm(this.$t('Delete'), this.$t('ConfirmDelete'))) {
                    this.loading = true
                    LookupAdminService.deleteLookup(id)
                        .then(() => {
                            this.loadLookups()
                        })
                        .catch(() => {
                            this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                        }).finally(() => this.loading = false)
                }
            },
            async deleteLookupItem(item) {
                if (await this.$root.$confirm(this.$t('Delete'), this.$t('ConfirmDelete'))) {
                    this.loading = true
                    LookupAdminService.deleteLookupItem(item.recordPK)
                        .then(() => {
                            this.loadLookupItems()
                        })
                        .catch(() => {
                            this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                        }).finally(() => this.loading = false)
                }
            },
            checkboxSurveyChanged() {

            },
            checkboxRelatedChanged() {

            },
        },
    }
</script>

<style>
</style>